// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CommentRead } from "./CommentRead";
import {
  CommentReadFromJSON,
  CommentReadFromJSONTyped,
  CommentReadToJSON,
  CommentReadToJSONTyped,
} from "./CommentRead";

/**
 *
 * @export
 * @interface PageCommentRead
 */
export interface PageCommentRead {
  /**
   *
   */
  total: number;
  /**
   *
   */
  items: Array<CommentRead>;
  /**
   *
   */
  limit?: number | null;
  /**
   *
   */
  offset?: number | null;
}

/**
 * Check if a given object implements the PageCommentRead interface.
 */
export function instanceOfPageCommentRead(value: object): value is PageCommentRead {
  if (!("total" in value) || value["total"] === undefined) return false;
  if (!("items" in value) || value["items"] === undefined) return false;
  return true;
}

export function PageCommentReadFromJSON(json: any): PageCommentRead {
  return PageCommentReadFromJSONTyped(json, false);
}

export function PageCommentReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PageCommentRead {
  if (json == null) {
    return json;
  }
  return {
    total: json["total"],
    items: (json["items"] as Array<any>).map(CommentReadFromJSON),
    limit: json["limit"] === undefined ? undefined : json["limit"] === null ? null : json["limit"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
  };
}

export function PageCommentReadToJSON(json: any): PageCommentRead {
  return PageCommentReadToJSONTyped(json, false);
}

export function PageCommentReadToJSONTyped(
  value?: PageCommentRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total: value["total"],
    items: (value["items"] as Array<any>).map(CommentReadToJSON),
    limit: value["limit"],
    offset: value["offset"],
  };
}
